import {Injectable, inject} from '@angular/core'
import type {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router'
import type {Theme} from '@cart/src/app/entities/modals/theme.model'
import {OrganizationParametersService} from '@services/organization-parameters.service'
import {ThemeService} from '@services/theme.service'

@Injectable({
  providedIn: 'root',
})
export class CustomOrganizationThemeGuard {
  readonly #themeService = inject(ThemeService)
  readonly #organizationParametersService = inject(OrganizationParametersService)

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return new Promise<boolean | UrlTree>(resolve => {
      const theme = this.getDynamicThemeOrganization()
      this.#themeService.setTheme()
      resolve(true)
    })
  }

  private getDynamicThemeOrganization(): Theme {
    return this.#organizationParametersService.getOrganizationCustomThemeParam()
  }
}
